import { useCallback, useEffect, useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import useApi from "../Api/Api";

const useProducts = (filterOverrides = {}) => {
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const [products, setProducts] = useState([]);
  const [pagy, setPagy] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeFilter, setActiveFilter] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState();
  const [searchFilter, setSearchFilter] = useState();

  const getProducts = useCallback(
    (page) => {
      let queryParams = { page };
      if (filterData.artist_id) {
        queryParams.artist_id = filterData.artist_id;
      }
      if (categoryFilter) {
        queryParams.category_id = categoryFilter;
      }
      if (activeFilter) {
        queryParams.active = true;
      }
      if (searchFilter) {
        queryParams.query = searchFilter;
      }
      if (filterOverrides) {
        queryParams.active = filterOverrides;
      }
      const queryString = Object.keys(queryParams)
        .map((param) => `${param}=${queryParams[param]}`)
        .join("&");
      filterData.artist_id &&
        api.get(`/products?${queryString}`).then((r) => {
          setProducts(r.data.data);
          setPagy(r.data.pagy);
        });
    },
    [
      api,
      filterData.artist_id,
      filterOverrides,
      categoryFilter,
      activeFilter,
      searchFilter,
    ]
  );

  useEffect(() => {
    filterData.artist_id && setPagy([]);
    setProducts([]);
  }, [filterData.artist_id]);

  useEffect(() => {
    getProducts(currentPage);
  }, [getProducts, currentPage]);

  const resetPagination = () => {
    setProducts([]);
    setPagy([]);
    setCurrentPage(1);
  };

  return {
    getProducts,
    products,
    pagy,
    currentPage,
    setCurrentPage,
    activeFilter,
    setActiveFilter,
    categoryFilter,
    setCategoryFilter,
    resetPagination,
    searchFilter,
    setSearchFilter,
  };
};

export default useProducts;
